<ng-container *ngIf="page == 'job-profile-pop-up' || page == 'job-card-1' || page == 'job-card'
|| page == 'candidate-card' || page == 'candidate-listing' || page == 'candidate-profile'">
  <div class="common-header-flex">
    <div class="f-1">
      <div>Send Connection Request</div>
    </div>
    <div>
      <button>
        <span class="common-close" (click)="closeConnectionProcess()">&times;</span>
      </button>
    </div>
  </div>
  <div class="hpanel">
    <div class="panel-body br-bt-none">
      <div class="connection-graphics">
        <img src="assets/images/connection-design.png" alt="">
      </div>
      <div class="alert alert-info addd-dngr" role="alert">
        It seems that you are not connected with the owner of the <span *ngIf="module == 'job'">job</span> <span
          *ngIf="module == 'candidate'">candidate</span>.
        Please, complete the connection process to proceed.
      </div>
      <div class="counterparts-container">

        <div class="counterpart-image">
          <img *ngIf="counterpartsDetails?.photo" class="photo-style" [src]="counterpartsDetails?.photo?.startsWith('http') ? counterpartsDetails?.photo : url + counterpartsDetails?.photo"
            alt="Object Photo">

          <div *ngIf="!counterpartsDetails?.photo">
            <div class="circles" [style.background-color]="getColor(counterpartsDetails?.fullname)">
              <div class="circle-text" [style.color]="getFullNameTextColor(counterpartsDetails?.fullname)">{{ getInitials(counterpartsDetails?.fullname) }}</div>
            </div>
          </div>

        </div>
        <div class="counterparts-details">
          <div class="ellipsces" title="{{counterpartsDetails?.fullname}}">{{counterpartsDetails?.fullname}}</div>
          <div class="designation-workplace">
            <span class="ellipsces" *ngIf="counterpartsDetails?.userType == 'RECRUITER'">{{counterpartsDetails?.userType
              | titlecase}}</span>
            <span class="ellipsces" *ngIf="counterpartsDetails?.userType == 'FREELANCE_RECRUITER'">Freelance
              Recruiter</span>
            <span class="ellipsces" *ngIf="counterpartsDetails?.userType == 'MANAGEMENT_TALENT_ACQUISITION'">Management
              Talent Acquisition</span>
            <span class="ellipsces" *ngIf="counterpartsDetails?.userType == 'BENCH_RECRUITER'">Bench Recruiter</span>
            <span class="ellipsces" *ngIf="counterpartsDetails?.userType == 'JOB_SEEKER'">Job Seeker</span>
            <span>&#64;</span>
            <span *ngFor="let work of counterpartsDetails?.workExperience">
              <div class="ellipsces" *ngIf="work?.currentOrganization">
                <span>{{work?.organisationName}}</span>
              </div>
            </span>
          </div>

          <div *ngFor="let work of counterpartsDetails?.workExperience">
            <div *ngIf="work?.currentOrganization">
              <div class="ellipsces">{{work?.city | titlecase}}, {{" "}} {{work?.state}}</div>
            </div>
          </div>
        </div>
        <div class="connection-actions">
          <div *ngIf="connectionStatus == 'REQUEST_PENDING' || connectionStatus == 'REQUEST_RECEIVED'">
            <div class="btn-group" style="display: contents;">
              <button type="button" class="btn accept" (click)="accept()">Accept Request</button>
              <button id="button-split" type="button" [matMenuTriggerFor]="menu" class="btn accept  ">
                <span class="caret"></span>
              </button>
            </div>
            <div class="connection-template-menu">
              <mat-menu #menu="matMenu" xPosition="before">
                <button class="mat-menu-height" mat-menu-item (click)="reject()">Reject Request</button>
              </mat-menu>
            </div>
          </div>
        </div>
        <div *ngIf="connectionStatus == 'NOT_CONNECTED'||connectionStatus == 'REJECTED'|| connectionStatus == 'CANCELLED'">
          <button class="btn primary-btn"  style="color:#fff !important;" (click)="connect()">
            Connect
          </button>
        </div>
        <div *ngIf="connectionStatus == 'REQUEST_SENT'">
          <button class="btn btn-danger" (click)="cancelConnectionRequest() ">
            Cancel Request
          </button>
        </div>
        <div ngbDropdown *ngIf="connectionStatus == 'CONNECTED'">
          <div class="btn-group smxv" dropdown [isOpen]="isOpen" (onShown)="onShown()" (onHidden)="onHidden()"
            (isOpenChange)="isOpenChange($event)">

            <a id="button-animated" dropdownToggle>
              <img src="assets/icon/icon-vert-thr-dot.png" alt="" srcset="" class="Vthree-dote">
            </a>
            <ul id="basic-link-dropdown" *dropdownMenu class="dropdown-menu" style="margin-left: -160px; " role="menu"
              aria-labelledby="basic-link">
              <li role="menuitem"><a class="dropdown-item" (click)="removeConnection()">Remove Connection</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="custom-panel-footer">
    <div class="panel-footer">
      <div class="footer-flex">
        <button class="btn btn-default" (click)="closeConnectionProcess()">
          Cancel
        </button>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="page == 'job-profile' || page == 'candidate-profile-1'">
  <div class="xs-counterparts-container">
    <div class="xs-conterparts-flex">
      <div class="xs-counterpart-image">
        <img *ngIf="counterpartsDetails?.photo" class="photo-style" [src]="counterpartsDetails?.photo?.startsWith('http') ? counterpartsDetails?.photo : url + counterpartsDetails?.photo"
          alt="Object Photo">
        <div *ngIf="!counterpartsDetails?.photo">
          <div class="circles" [style.background-color]="getColor(counterpartsDetails?.fullname)">
            <div class="circle-text" [style.color]="getFullNameTextColor(counterpartsDetails?.fullname)">{{ getInitials(counterpartsDetails?.fullname) }}</div>
          </div>
        </div>

        <div *ngIf="connectionStatus == 'CONNECTED'">
          <ng-icon name="tablerLink" class="link primary-color" title="You are connected with this owner"></ng-icon>
        </div>

      </div>
      <div class="xs-counterparts-details">
        <div class="xs-ellipsces fw-bold ft-inherit" title="{{counterpartsDetails?.fullname}}">{{counterpartsDetails?.fullname}}</div>
        <div class="xs-designation-workplace">
          <span class="xs-ellipsces fw-bold" *ngIf="counterpartsDetails?.userType == 'RECRUITER'"
            title="{{counterpartsDetails?.userType}}">{{counterpartsDetails?.userType | titlecase}}</span>
          <span class="xs-ellipsces" *ngIf="counterpartsDetails?.userType == 'FREELANCE_RECRUITER'"
            title="{{counterpartsDetails?.userType}}">Freelance Recruiter</span>
          <span class="xs-ellipsces" *ngIf="counterpartsDetails?.userType == 'MANAGEMENT_TALENT_ACQUISITION'"
            title="{{counterpartsDetails?.userType}}">Management Talent Acquisition</span>
          <span class="xs-ellipsces" *ngIf="counterpartsDetails?.userType == 'BENCH_RECRUITER'"
            title="{{counterpartsDetails?.userType}}">Bench Recruiter</span>
          <span class="xs-ellipsces" *ngIf="counterpartsDetails?.userType == 'JOB_SEEKER'"
            title="{{counterpartsDetails?.userType}}">Job Seeker</span>
        </div>
        <div *ngIf="values?.user?.userType!='FREELANCE_RECRUITER'">
          <div *ngFor="let work of counterpartsDetails?.workExperience">
            <div *ngIf="work?.currentOrganization">
              <div class="xs-ellipsces" title="{{work?.organisationName}}">
                {{work?.organisationName}}
              </div>
              <div class="xs-ellipsces" title="{{work?.city | titlecase}}, {{ work?.state}}">{{work?.city | titlecase}},
                {{" "}} {{work?.state}}</div>
            </div>
          </div>
        </div>


        <div *ngIf="values?.user?.userType=='FREELANCE_RECRUITER'">
          <div *ngFor="let work of counterpartsDetails?.workExperience">
            <div *ngIf="module == 'job'">
              <div *ngIf="values?.jobPostedBehalfOf == work.organisationName">
                <div class="xs-ellipsces" title="{{work?.organisationName}}">
                  {{work?.organisationName}}
                </div>
                <div class="xs-ellipsces" title="{{work?.city | titlecase}}, {{ work?.state}}">{{work?.city |
                  titlecase}}, {{" "}} {{work?.state}}</div>
              </div>
            </div>
            <div *ngIf="module == 'candidate'">
              <div *ngIf="values?.postedBehalfOf == work.organisationName">
                <div class="xs-ellipsces" title="{{work?.organisationName}}">
                  {{work?.organisationName}}
                </div>
                <div class="xs-ellipsces">{{work?.city | titlecase}}, {{" "}} {{work?.state}}</div>
              </div>
            </div>
          </div>
        </div>
       
      </div>
      <div class="xs-counter-part-connection">
        <div *ngIf="values?.jobPostedBy != userId && connectionStatus == 'CONNECTED' || values?.createdBy!= userId && connectionStatus == 'CONNECTED'"
        [ngClass]="{disabled : !values?.availability || values?.status != 'ACTIVE' }">
        <button class="btn primary-btn" (click)="sendMessage(values)">
          Live Chat
          <!-- <ng-icon name="tablerMail" class="jwsk" aria-hidden="true"></ng-icon> -->
          <ng-icon name="tablerMail" aria-hidden="true"></ng-icon>
        </button>
      </div>
        <div class="xs-connection-actions">
          <div *ngIf="connectionStatus == 'REQUEST_PENDING' || connectionStatus == 'REQUEST_RECEIVED'">
            <div class="btn-group" style="display: contents;">
              <button type="button" class="btn btn-sm accept" (click)="accept()">Accept</button>
              <button id="button-split" type="button" [matMenuTriggerFor]="menu" class="btn accept btn-sm ">
                <span class="caret"></span>
              </button>
            </div>
            <div class="connection-template-menu">
              <mat-menu #menu="matMenu" xPosition="before" panelClass="custom-menu-panel">
                <button class="mat-menu-height" mat-menu-item (click)="reject()">Reject</button>
              </mat-menu>
            </div>
          </div>
          <div *ngIf="connectionStatus == 'NOT_CONNECTED'||connectionStatus == 'REJECTED' || connectionStatus == 'CANCELLED'">
            <button class="btn primary-btn btn-sm"  style="color:#fff !important;" (click)="connect()">
              Connect
            </button>
          </div>
          <div *ngIf="connectionStatus == 'REQUEST_SENT'">
            <button class="btn btn-danger btn-sm" (click)="cancelConnectionRequest() ">
              Cancel Request
            </button>
          </div>
        </div>
      </div>
    </div>


  </div>
</ng-container>

<!-- ════════════════════════════════════════════════════════════════
     V3 DESIGN — Connection actions only (no profile, no avatar)
     Used in jc-v3 detail header where profile is already rendered
     ════════════════════════════════════════════════════════════════ -->
<!-- Both V3 detail headers (job + candidate) render the same set of
     connection actions; the surrounding owner avatar / name / org is
     drawn by the parent template, so this block stays scoped to the
     Connect / Chat / Cancel / Accept-Reject buttons only. -->
<!-- ════════════════════════════════════════════════════════════════
     V3 "Submitted by" / "Posted by" strip — Connect text button +
     Chat icon-only button. Used by the candidate/job profile slider
     beneath the header (gigsumo_job_center_v2(16).html lines 1715-1720).
     Status-aware: Connect collapses into Pending / Connected pill once
     the request has been sent / accepted; Chat icon stays visible.
     ════════════════════════════════════════════════════════════════ -->
<ng-container *ngIf="page == 'jc-v3-cps-rec-strip'">
  <div class="jc-v3-cps-rec-btns">
    <!-- Primary action — Connect / Cancel / Accept / Connected -->
    <button *ngIf="connectionStatus == 'NOT_CONNECTED' || connectionStatus == 'REJECTED' || connectionStatus == 'CANCELLED' || !connectionStatus"
            type="button"
            class="jc-v3-cps-rec-btn jc-v3-cps-rec-btn-outline"
            (click)="connect()">
      Connect
    </button>
    <button *ngIf="connectionStatus == 'REQUEST_SENT'"
            type="button"
            class="jc-v3-cps-rec-btn jc-v3-cps-rec-btn-danger"
            (click)="cancelConnectionRequest()">
      Cancel Request
    </button>
    <button *ngIf="connectionStatus == 'REQUEST_PENDING' || connectionStatus == 'REQUEST_RECEIVED'"
            type="button"
            class="jc-v3-cps-rec-btn jc-v3-cps-rec-btn-primary"
            (click)="accept()">
      Accept Request
    </button>
    <span *ngIf="connectionStatus == 'CONNECTED'"
          class="jc-v3-cps-rec-pill">Connected</span>

    <!-- Chat — icon-only. Normally always visible, but when
         hideChatUntilConnected is set (Job Center job slider) it only
         shows once a connection is established. -->
    <button type="button"
            *ngIf="!hideChatUntilConnected || connectionStatus == 'CONNECTED'"
            class="jc-v3-cps-rec-btn jc-v3-cps-rec-btn-outline jc-v3-cps-rec-btn-icon"
            (click)="sendMessage(values)"
            title="Chat"
            aria-label="Chat">
      <!-- Same speech-bubble glyph the header + Chat tab use, instead of the
           tablerMessage font icon (whose inner lines made it look different). -->
      <svg class="jc-v3-cps-rec-btn-chat-ico" xmlns="http://www.w3.org/2000/svg"
           width="13" height="13" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
      </svg>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="page == 'jc-v3-job-profile' || page == 'jc-v3-candidate-profile'">
  <div class="jc-v3-connection-actions" style="display:flex;align-items:center;gap:6px;">
    <!-- Connected: Chat + kebab with Remove.
         The previous disabled gate `!values?.availability || values?.status != 'ACTIVE'`
         broke job-side rendering because jobs don't have an `availability`
         field — `!undefined` is `true`, so the Chat button always picked up
         `.disabled { opacity: 0.55; pointer-events: none }` and looked
         invisible in the detail header. The check now only kicks in when
         the field is *explicitly* falsy / non-active, which keeps candidate
         behaviour intact. -->
    <ng-container *ngIf="connectionStatus == 'CONNECTED'">
      <button class="jc-v3-btn jc-v3-btn-outline jc-v3-btn-sm"
        [ngClass]="{disabled : values?.availability === false || (values?.status != null && values?.status !== 'ACTIVE') }"
        (click)="sendMessage(values)">
        <ng-icon name="tablerMail" aria-hidden="true" style="margin-right:4px;"></ng-icon>Chat
      </button>
      <div class="btn-group" dropdown [isOpen]="isOpenV3" (isOpenChange)="onV3DropdownOpenChange($event)">
        <a dropdownToggle style="cursor:pointer;color:#9CA3AF;font-size:14px;">
          <ng-icon name="tablerDotsVertical"></ng-icon>
        </a>
        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
          <li role="menuitem"><a class="dropdown-item" (click)="removeConnection()">Remove Connection</a></li>
        </ul>
      </div>
    </ng-container>

    <!-- Not Connected: Connect button -->
    <ng-container *ngIf="connectionStatus == 'NOT_CONNECTED' || connectionStatus == 'REJECTED' || connectionStatus == 'CANCELLED'">
      <button class="jc-v3-btn jc-v3-btn-outline jc-v3-btn-sm" (click)="connect()">
        Connect
      </button>
    </ng-container>

    <!-- Request Sent: Cancel Request -->
    <ng-container *ngIf="connectionStatus == 'REQUEST_SENT'">
      <button class="jc-v3-btn jc-v3-btn-sm" (click)="cancelConnectionRequest()"
        style="background:#FEF2F2;color:#DC2626;border:1px solid #FECACA;">
        Cancel Request
      </button>
    </ng-container>

    <!-- Request Received: Accept / Reject -->
    <ng-container *ngIf="connectionStatus == 'REQUEST_PENDING' || connectionStatus == 'REQUEST_RECEIVED'">
      <button class="jc-v3-btn jc-v3-btn-primary jc-v3-btn-sm" (click)="accept()">Accept</button>
      <button class="jc-v3-btn jc-v3-btn-sm" (click)="reject()"
        style="background:#FEF2F2;color:#DC2626;border:1px solid #FECACA;">
        Reject
      </button>
    </ng-container>

  </div>
</ng-container>